import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

const BASE = getBaseUrl('/auth/');

export async function getAuthConfig() {
    return appRequest.doGetRequest(`${BASE}config`);
}

export async function updateAuthConfig(data) {
    return appRequest.doPatchRequest(`${BASE}config`, data);
}

export async function getActiveSessions() {
    return appRequest.doGetRequest(`${BASE}sessions`);
}

export async function getSessionHistory(page, pageSize) {
    return appRequest.doGetRequest(`${BASE}sessions/history?page=${page}&pageSize=${pageSize}`);
}

export async function revokeSession(id) {
    return appRequest.doDeleteRequest(`${BASE}sessions/${id}`);
}
